module.exports = __webpack_public_path__ + "assets/img/Logitech-G-1-Social-Static-Ad.6d5c93ea.webp";